const module = { name: 'swig/customFilters', exports: {} }; const exports = module.exports;



const RegExes = {
    HTTP: /^http:\/\//i,
    NOT_NUM: /\D/g,
    STATF: /^http:\/\/www.statf.com/i,
}
function decode(text) {
    return decodeURI(text);
}
function formatPhoneNumber(input) {
    if (!input || typeof input !== 'string') {
        return '';
    }
    const phone = input.replace(RegExes.NOT_NUM, '');
    if (phone.length !== 10) {
        return input;
    }
    return `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;
}
function formatRating(input, delimiter) {
    if (!input) {
        return '';
    }
    delimiter = delimiter || '';
    input = input.toUpperCase();
    switch (input) {
        case 'G':
        case 'PG':
        case 'R':
            return `${input}${delimiter}`;
        case 'PG13':
        case 'PG-13':
        case 'PG 13':
            return `PG-13${delimiter}`;
        case 'NC17':
        case 'NC-17':
        case 'NC 17':
            return `NC-17${delimiter}`;
        default:
            return '';
    }
}
function formatRuntime(input) {
    const totalMinutes = parseInt(input, 10);
    if (!totalMinutes) {
        return '';
    }
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return (hours ? `${hours} hr ` : '') + (minutes ? `${minutes} min` : '');
}
function ifAElseB(condition, trueValue, falseValue) {
    return condition ? trueValue : falseValue;
}
function secureImageUri(input) {
    if (RegExes.STATF.test(input)) {
        return input.replace(RegExes.STATF, 'https://images.fandango.com');
    }
    return input.replace(RegExes.HTTP, 'https://');
}
function secureUri(input) {
    return input.replace(RegExes.HTTP, 'https://');
}
function addFilters(setFilter) {
    setFilter('decode', decode);
    setFilter('formatPhoneNumber', formatPhoneNumber);
    setFilter('formatRating', formatRating);
    setFilter('formatRuntime', formatRuntime);
    setFilter('ifAElseB', ifAElseB);
    setFilter('secureImageUri', secureImageUri);
    setFilter('secureUri', secureUri);
}
module.exports = {
    addFilters
};
export default module.exports;